<div class="min-h-full flex flex-col">
  <app-header [title]="'Send Email'">
    <p below-title-slot>{{ groupName }}</p>
    <button
      additional-slot
      id="close-modal-button"
      class="btn-primary m-0 flex items-center justify-center w-min p-1"
      (click)="dismissModal()"
    >
      <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
    </button>
  </app-header>
  <app-loader [loadingState]="loadingState$ | async" relativeWidthAndHeight="true" [top]="64"></app-loader>
  @if ((loadingState$ | async) !== 'loading') {
    <div class="flex-grow p-4 pt-0 overflow-y-auto flex flex-col gap-4">
      <div class="grid gap-3 mb-3 text-sm">
        <form [formGroup]="emailInputForm">
          <div class="flex flex-row justify-between">
            <div
              class="form-input flex-1 mr-4"
              [ngClass]="{
                'has-error': subjectEditable && emailInputForm.controls['subject'].invalid,
              }"
            >
              @if (!subjectEditable || !emailInputForm.controls['subject'].invalid) {
                <label for="email-subject">Subject</label>
              }
              @if (subjectEditable && emailInputForm.controls['subject'].hasError('required')) {
                <label for="email-subject" class="gap-0.5">
                  <ion-icon name="alert-circle" class="size-4"></ion-icon>
                  Email subject is required
                </label>
              }
              @if (subjectEditable) {
                <input
                  id="email-subject"
                  type="text"
                  formControlName="subject"
                  class="w-full border border-grey-concrete rounded p-2 text-base shadow-none"
                  [ngClass]="{
                    '!border-bright-crimson text-bright-crimson':
                      emailInputForm.controls['subject'].invalid && emailInputForm.controls['subject'].touched,
                  }"
                  [placeholder]="'Subject'"
                  maxlength="200"
                />
              } @else {
                <p class="font-normal">{{ subject }}</p>
              }
            </div>
            <div class="form-input w-1/3">
              <label>From</label>
              <div>
                <span class="font-normal block">ESET Sales</span>
                <span class="font-normal block text-grey-blue/90">&lt;{{ salesEmail }}&gt;</span>
              </div>
            </div>
          </div>
          <app-email-input
            class="relative z-0"
            (emailsData)="onEmailsUpdate($event)"
            [defaultValue]="defaultEmail"
            [required]="true"
            [groupId]="groupId"
          ></app-email-input>
          <div
            class="form-input mt-4 relative z-100"
            [ngClass]="{
              'has-error': emailInputForm.controls['body'].invalid,
            }"
          >
            @if (!emailInputForm.controls['body'].invalid) {
              <label>Email Body</label>
            }
            @if (emailInputForm.controls['body'].invalid && emailInputForm.controls['body'].hasError('required')) {
              <label class="gap-0.5">
                <ion-icon name="alert-circle" class="size-4"></ion-icon>
                Email body is required
              </label>
            }
            @if (emailInputForm.controls['body'].hasError('pattern')) {
              <label class="gap-0.5">
                <ion-icon name="alert-circle" class="size-4"></ion-icon>
                Email body must contain text
              </label>
            }
            <textarea
              id="email-body"
              formControlName="body"
              class="w-full border border-grey-concrete rounded p-3 min-h-[200px] text-base shadow-none white-space: pre-wrap"
              [ngClass]="{
                '!border-bright-crimson text-bright-crimson':
                  emailInputForm.controls['body'].invalid && emailInputForm.controls['body'].touched,
              }"
              rows="12"
              minlength="1"
              data-1p-ignore
            ></textarea>
          </div>
          @if (infoText) {
            <div
              class="bg-blue-bright/10 p-2 text-pretty rounded text-blue-bright font-medium flex items-center mt-4 text-xs"
            >
              <ion-icon class="mr-2 text-xl w-full max-w-[20px]" name="information-circle"></ion-icon>
              <div>
                {{ infoText }}
              </div>
            </div>
          }
        </form>
        @if (nextStepEnabled) {
          <app-next-step-form
            [nextStepForm]="nextStepForm"
            class="border-t border-grey-concrete pt-3"
          ></app-next-step-form>
        }
      </div>
    </div>
  }
  @if ((groupId && (loadingState$ | async) == 'loaded') || (!groupId && leadId)) {
    <footer class="flex gap-2 p-3 w-full border-t-2 border-grey-concrete justify-end">
      <button type="button" (click)="dismissModal()" class="btn-default text-sm">Cancel</button>
      <button
        type="submit"
        id="custom-email-submit"
        (click)="sendEmail()"
        [disabled]="emailInputForm.invalid"
        class="btn-primary text-sm"
      >
        Send Email
      </button>
    </footer>
  }
</div>
